import React, { useState } from 'react';
import { SendMail } from '../request/apiRquest';
import { Button, message } from 'antd';

const inputStyle = {
    backgroundColor: "#f5f5f5",
    border: "1px solid #ccc",
    borderRadius: "6px",
    padding: "12px",
    fontSize: "14px",
    width: "100%",
    marginBottom: "15px",
    color: "#333",
};

const ContactForm = ({ onClose }) => {
    message.config({ top: 100 });

    const [loading, setLoading] = useState(false);
    const [maildata, setMailData] = useState({
        FromName: "",
        FromEmail: "",
        ContactNo: "",
        Message: "",
        Language: ""
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!maildata?.ContactNo && !maildata?.FromEmail) {
            message.warning("Please fill the contact details before submitting");
            setLoading(false);
            return;
        }

        try {
            await SendMail(maildata);
            message.success("Your message has been sent successfully!", 3);
            setMailData({
                FromName: "",
                FromEmail: "",
                ContactNo: "",
                Message: "",
                Language: ""
            });
           if (onClose) {
    onClose();
}
        } catch (error) {
            console.error(error);
            message.error("Failed to send your message. Please try again.", 4);
        } finally {
            setLoading(false);
        }
    };

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setMailData({ ...maildata, [name]: value });
    };

    return (
        <div>
            <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
                Fill out the form below and our team will respond within 24 hours.
            </p>

            <input
                type="text"
                name="FromName"
                placeholder="Name"
                value={maildata.FromName}
                onChange={handleChangeInput}
                style={inputStyle}
            />

            <input
                type="email"
                name="FromEmail"
                placeholder="Email"
                value={maildata.FromEmail}
                onChange={handleChangeInput}
                style={inputStyle}
            />

            <input
                type="number"
                name="ContactNo"
                placeholder="Contact Number"
                value={maildata.ContactNo}
                onChange={handleChangeInput}
                style={inputStyle}
            />

            <select
                name="Language"
                value={maildata.Language}
                onChange={handleChangeInput}
                style={{ ...inputStyle, color: "#333" }}
            >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Arabic">Arabic</option>
                <option value="Hindi">Hindi</option>
            </select>

            <textarea
                name="Message"
                placeholder="Message"
                value={maildata.Message}
                onChange={handleChangeInput}
                rows="2"
                style={{ ...inputStyle, resize: "none" }}
            ></textarea>

            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <Button
                  
                    onClick={handleSubmit}
                    loading={loading}
                    style={{ flex: 1, backgroundColor:"#fda94f", border:'none', color:'white'}}
                >
                    Submit
                </Button>
                <Button danger onClick={onClose} style={{ flex: 1 }}>
                    Cancel
                </Button>
            </div>
        </div>
    );
};

export default ContactForm;
